import { originalSourceToImageMap } from 'components/BusinessSource/specs'
import { defaultWebsiteIcon } from 'containers/VerticalPage/common/utils'

export const usePlatformIcon = (platformName: string) => {
  return originalSourceToImageMap[platformName] || originalSourceToImageMap[defaultWebsiteIcon]
}
